/* CUBE Clean — progressive enhancement. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile nav drawer ---------- */
  function initDrawer() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    if (!toggle || !drawer) return;
    var closeEls = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      // simple focus trap
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    toggle.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
  }

  /* ---------- Accordion ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (acc) {
      acc.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('.accordion__item');
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', String(!expanded));
          item.classList.toggle('is-open', !expanded);
          var icon = trigger.querySelector('.accordion__icon');
          if (icon) icon.textContent = expanded ? '+' : '–';
        });
      });
    });
  }

  /* ---------- Segmented controls (purchase toggle, scent) ---------- */
  function initSegmented() {
    document.querySelectorAll('[data-segmented]').forEach(function (group) {
      var input = group.parentNode.querySelector('input[type="hidden"]');
      group.querySelectorAll('.segmented__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          group.querySelectorAll('.segmented__option').forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-pressed', 'false');
          });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-pressed', 'true');
          if (input) input.value = opt.getAttribute('data-value') || opt.textContent.trim();
          var err = group.parentNode.querySelector('[data-scent-error]');
          if (err) err.hidden = true;
        });
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product form: variant + selling-plan selection ---------- */
  function initProductForm() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var variantsEl = form.querySelector('[data-variants]');
    var pricesEl = form.querySelector('[data-variant-prices]');
    var planPricesEl = form.querySelector('[data-plan-prices]');
    var variants = [];
    var prices = {};       // variantId -> one-time formatted price
    var planPrices = {};   // "variantId:planId" -> subscription formatted price
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    try { prices = JSON.parse(pricesEl.textContent); } catch (e) {}
    try {
      JSON.parse(planPricesEl.textContent).forEach(function (e) { planPrices[e.v + ':' + e.p] = e.price; });
    } catch (e) {}

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');
    var optionGroups = Array.prototype.slice.call(form.querySelectorAll('[data-product-option]'));

    var currentVariantId = idInput ? idInput.value : null;
    var currentPlan = '';

    function renderPrice() {
      if (!priceEl) return;
      var planKey = currentVariantId + ':' + currentPlan;
      if (currentPlan && planPrices[planKey]) { priceEl.textContent = planPrices[planKey]; }
      else if (prices[currentVariantId]) { priceEl.textContent = prices[currentVariantId]; }
    }

    function selectOne(group, opt) {
      group.querySelectorAll('.segmented__option').forEach(function (o) {
        o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false');
      });
      opt.classList.add('is-selected'); opt.setAttribute('aria-pressed', 'true');
    }
    function selectedValues() {
      return optionGroups.map(function (g) {
        var s = g.querySelector('.is-selected');
        return s ? s.getAttribute('data-value') : null;
      });
    }
    function eq(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) { if (String(a[i]) !== String(b[i])) return false; }
      return true;
    }
    function allSelected() {
      return optionGroups.length > 0 && optionGroups.every(function (g) { return g.querySelector('.is-selected'); });
    }
    function setAdd(enabled, label) {
      if (!addBtn) return;
      addBtn.disabled = !enabled;
      if (label) addBtn.innerHTML = label;
    }
    function updateVariant() {
      if (!variants.length || !optionGroups.length) return;
      // No default selection: keep Add to cart disabled until every option is chosen.
      if (!allSelected()) {
        currentVariantId = null;
        if (idInput) idInput.value = '';
        setAdd(false, 'Add to cart <span aria-hidden="true">→</span>');
        return;
      }
      var sel = selectedValues();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (eq(variants[i].options, sel)) { match = variants[i]; break; }
      }
      if (!match) { currentVariantId = null; if (idInput) idInput.value = ''; setAdd(false, 'Unavailable'); return; }
      currentVariantId = match.id;
      if (idInput) idInput.value = match.id;
      renderPrice();
      setAdd(match.available, match.available ? 'Add to cart <span aria-hidden="true">→</span>' : 'Sold out');
      if (typeof renderCalc === 'function') renderCalc(); // refresh estimate with this variant's pack size
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.segmented__option').forEach(function (opt) {
        opt.addEventListener('click', function () { selectOne(group, opt); updateVariant(); });
      });
    });
    updateVariant(); // initial state: disabled until a variant is picked

    // Purchase type: one-time vs The Un-Subscription (refill reminders — no auto-charge).
    // The "on" option enables a line-item property so a Klaviyo flow can send a reorder reminder.
    var ptGroup = form.querySelector('[data-purchase-type] .segmented');
    var reminderInput = form.querySelector('[data-reminder-input]');
    var ptPanel = form.querySelector('[data-pt-panel]');
    var freqInput = form.querySelector('[data-calc-freq-input]');
    var windowInput = form.querySelector('[data-calc-window-input]');
    var bucketInput = form.querySelector('[data-calc-bucket-input]');
    function setReminder(on) {
      if (reminderInput) reminderInput.disabled = !on;
      if (freqInput) freqInput.disabled = !on;
      if (windowInput) windowInput.disabled = !on;
      if (bucketInput) bucketInput.disabled = !on;
      if (ptPanel) ptPanel.hidden = !on;
    }
    if (ptGroup) {
      ptGroup.querySelectorAll('.segmented__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          selectOne(ptGroup, opt);
          setReminder(opt.getAttribute('data-reminder') === 'on');
        });
      });
      var ptSel = ptGroup.querySelector('.is-selected');
      setReminder(!!ptSel && ptSel.getAttribute('data-reminder') === 'on');
    }

    // Refill calculator: dish frequency -> estimated reminder date
    var calcSel = form.querySelector('[data-calc-frequency]');
    var calcOut = form.querySelector('[data-calc-result]');
    if (calcSel && calcOut) {
      var defaultLoads = parseInt(calcSel.getAttribute('data-loads'), 10) || 64;
      var currentLoads = function () {
        // Loads per box from the SELECTED variant's name (e.g. "… / 32 Pack" -> 32); else the default.
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(currentVariantId)) {
            var m = String(variants[i].title || '').match(/(\d[\d,]*)/);
            return m ? parseInt(m[1].replace(/,/g, ''), 10) : defaultLoads;
          }
        }
        return defaultLoads;
      };
      var renderCalc = function () {
        var every = parseInt(calcSel.value, 10) || 1;
        var loads = currentLoads();
        var d = new Date();
        d.setDate(d.getDate() + (every * loads));
        calcOut.textContent = 'We’ll remind you around ' +
          d.toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) + '.';
        // Log the answer on the order (line-item properties)
        var label = calcSel.options[calcSel.selectedIndex] ? calcSel.options[calcSel.selectedIndex].text : calcSel.value;
        if (freqInput) freqInput.value = 'every ' + label;
        if (windowInput) windowInput.value = '~' + (every * loads) + ' days';
        if (bucketInput) bucketInput.value = (every <= 2) ? 'Frequent' : 'Occasional';
      };
      calcSel.addEventListener('change', renderCalc);
      renderCalc();
    }
  }

  /* ---------- Password page: submit sample request to Klaviyo (client API) ---------- */
  function initPasswordForm() {
    var form = document.querySelector('[data-password-form]');
    if (!form) return;

    // Scent is required (no default). This guard is registered first, so on submit it runs before
    // the Klaviyo handler below and before any native POST — blocking both if no scent is chosen.
    var scentEl = form.querySelector('[data-required-scent]');
    if (scentEl) {
      form.addEventListener('submit', function (e) {
        if (!scentEl.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var scentErr = form.querySelector('[data-scent-error]');
          if (scentErr) scentErr.hidden = false;
          var grp = form.querySelector('[data-segmented]');
          if (grp && grp.scrollIntoView) grp.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    }

    var key = form.getAttribute('data-klaviyo-key');
    var list = form.getAttribute('data-klaviyo-list');
    if (!key || !list) return; // not Klaviyo — let the form POST to its action

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      var val = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
      var consentEl = form.querySelector('[name="marketing_consent"]');
      var subscribed = !!(consentEl && consentEl.checked);
      var smsEl = form.querySelector('[name="sms_consent"]');
      var smsOptedIn = !!(smsEl && smsEl.checked);

      // Normalize phone to E.164 (US/CA) so Klaviyo accepts it; keep the raw entry as a property too.
      var rawPhone = val('phone');
      var phoneDigits = rawPhone.replace(/\D/g, '');
      var phoneE164 = '';
      if (phoneDigits.length === 10) { phoneE164 = '+1' + phoneDigits; }
      else if (phoneDigits.length === 11 && phoneDigits.charAt(0) === '1') { phoneE164 = '+' + phoneDigits; }

      var profile = {
        email: val('email'),
        first_name: val('first_name'),
        last_name: val('last_name'),
        properties: { 'Scent preference': val('scent'), 'Phone': rawPhone, 'SMS consent': (smsOptedIn ? 'Yes' : 'No'), 'Pre-order': true, 'Source': 'Reserve my pre-order' }
      };
      if (phoneE164) { profile.phone_number = phoneE164; }

      var endpoint, body;
      if (subscribed) {
        endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key);
        body = { data: { type: 'subscription', attributes: { custom_source: 'Reserve my pre-order', profile: { data: { type: 'profile', attributes: profile } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
      } else {
        endpoint = 'https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(key);
        body = { data: { type: 'profile', attributes: profile } };
      }

      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
        .then(function (r) {
          if (r.ok) {
            var success = form.querySelector('[data-form-success]');
            Array.prototype.forEach.call(form.children, function (c) { if (c !== success) c.style.display = 'none'; });
            if (success) success.hidden = false;
          } else {
            r.text().then(function (t) { try { console.error('[CUBE] Klaviyo error', r.status, t); } catch (e) {} });
            if (btn) { btn.disabled = false; btn.innerHTML = original; }
            alert('Sorry — something went wrong. Please try again.');
          }
        })
        .catch(function (err) {
          try { console.error('[CUBE] Klaviyo request failed', err); } catch (e) {}
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          alert('Sorry — something went wrong. Please try again.');
        });
    });
  }

  /* ---------- Product gallery: thumbnail → main swap ---------- */
  function initGallery() {
    var mainBox = document.querySelector('[data-gallery-main]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!mainBox || !thumbs.length) return;
    var mainImg = mainBox.querySelector('img');
    if (!mainImg) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) { mainImg.src = full; mainImg.removeAttribute('srcset'); }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- Cart: instant AJAX remove + live count ---------- */
  function initCart() {
    var removes = document.querySelectorAll('[data-cart-remove]');
    if (!removes.length) return;
    var subtotalEl = document.querySelector('[data-cart-subtotal]');

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    }

    removes.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var line = link.closest('[data-cart-line]');
        var key = line ? line.getAttribute('data-line-key') : null;
        if (!key) { window.location.href = link.href; return; }
        link.textContent = 'Removing…';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function (cart) {
            if (cart.item_count === 0) { window.location.reload(); return; }
            if (line && line.parentNode) line.parentNode.removeChild(line);
            if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
            setCount(cart.item_count);
          })
          .catch(function () { window.location.href = link.href; });
      });
    });
  }

  function init() {
    initDrawer();
    initAccordions();
    initSegmented();
    initQty();
    initProductForm();
    initPasswordForm();
    initGallery();
    initCart();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
